import { render, staticRenderFns } from "./ContactsAvailable.vue?vue&type=template&id=156b747f&"
import script from "./ContactsAvailable.vue?vue&type=script&lang=js&"
export * from "./ContactsAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports